import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=bd8b47c0&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=js&"
export * from "./MyOrders.vue?vue&type=script&lang=js&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=bd8b47c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b47c0",
  null
  
)

export default component.exports